const env = process.env.REACT_APP_ENV;

let baseURL;
let vertexListingsURL;
let leaseSignURL;
let vertexEaseURL;
const googleMapsAPIKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

switch (env) {
  case "development":
    baseURL = process.env.REACT_APP_BASE_URL_DEV;
    vertexListingsURL = process.env.REACT_APP_VERTEXLISTINGS_URL_DEV;
    leaseSignURL = process.env.REACT_APP_LEASESIGN_URL_DEV;
    vertexEaseURL = process.env.REACT_APP_VERTEXEASE_DEV;
    break;
  case "staging":
    baseURL = process.env.REACT_APP_BASE_URL_STAGING;
    break;
  case "production":
    baseURL = process.env.REACT_APP_BASE_URL_PRODUCTION;
    vertexListingsURL = process.env.REACT_APP_VERTEXLISTINGS_URL_PRODUCTION;
    leaseSignURL = process.env.REACT_APP_LEASESIGN_URL_PRODUCTION;
    vertexEaseURL = process.env.REACT_APP_VERTEXEASE_PRODUCTION;
    break;

  default:
    baseURL = process.env.REACT_APP_BASE_URL_LOCAL;
    vertexListingsURL = process.env.REACT_APP_VERTEXLISTINGS_URL_DEV;
    leaseSignURL = process.env.REACT_APP_LEASESIGN_URL_DEV;
    vertexEaseURL = process.env.REACT_APP_VERTEXEASE_DEV;
}

export default {
  env: env,
  baseUrl: baseURL,
  vertexListingsURL,
  leaseSignURL,
  vertexEaseURL,
  googleMapsAPIKey
};
